import { toggleSingleSceneObject } from "../../togglers/toggleSingleSceneObject";
import { DEFAULT_Y } from "../stoyki/pos_map";

export const changeElektropanelSP = (isChecked) => {
    "elektropanel__stol__ps_kp__500x500";
    const tempName = servObj.tempName;
    const width = servObj.tableSize.tableWidth.current;
    const depth = servObj.tableSize.tableDepth.current;
    const name = `elektropanel__stol__${tempName}__${width}x${depth}`;

    toggleSingleSceneObject({
        allObjects: servObj.allElektropanelSP,
        activeArray: servObj.activeElektropanelSP,
        name,
        isChecked,
        position: { y: DEFAULT_Y },
    });
};
